/*
 * Copyright '2025' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
import { environment } from "../../../../environments/environments";

export class FeedbackService {
  private readonly feedbackEndpoint = environment.feedbackEndpoint;

  public window: Window;

  public constructor(window: Window) {
    this.window = window;
  }

  public async getFeedback(): Promise<any> {
    try {
      const response = await this.window.fetch(this.feedbackEndpoint, {
        method: "GET",
        headers: {
          accept: "application/json",
        },
        cache: "no-cache",
        mode: "cors",
        credentials: "include",
        referrerPolicy: "no-referrer",
      });
      if (response.status !== 200) {
        throw new Error(
          `Fetch failed with ${response.status} status code. Details: ${response.statusText}`
        );
      }
      return await response.json();
    } catch (e) {
      console.error(
        "An exception has been encountered while trying to fetch feedback",
        e
      );
      throw e;
    }
  }

  public async setFeedback(value: any): Promise<void> {
    try {
      if (!value) {
        return;
      }
      if (typeof value === "string") {
        value = value.toLowerCase() === "true";
      }
      const response = await this.window.fetch(this.feedbackEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ current_state: value }),
        cache: "no-cache",
        mode: "cors",
        credentials: "include",
        referrerPolicy: "no-referrer",
      });
      if (response.status !== 200) {
        throw new Error(
          `Fetch failed with ${response.status} status code. Details: ${response.statusText}`
        );
      }
    } catch (e) {
      console.error(
        "An exception has been encountered while trying to set feedback",
        e
      );
    }
  }
}
